module.exports = __webpack_public_path__ + "img/splicing_prograss_four_ssss.b5c0b029.png";